export default __webpack_public_path__ + "static/media/blustery_bay.e61a70bc.svg";